import { RegisterForm } from '@/components/register-form/register-form';
import { Wrapper } from '@/components/wrapper/wrapper';

interface HowItWorksSectionProps {
  organizationId: string;
}

export function HowItWorksSection({ organizationId }: HowItWorksSectionProps) {
  return (
    <Wrapper title='Jak to funguje?'>
      <p className='text-sm leading-relaxed text-[#1a1a1a]/80'>
        Otevřete{' '}
        <span className='font-semibold text-[#1a1a1a]'>
          chatovací okno v pravé dolní části obrazovky.
        </span>{' '}
        Zeptejte se mě z pozice Vašeho zákazníka. Zvládnu odpovědi jako
        <span className='font-semibold text-[#1a1a1a]'>
          {' '}
          reálný kolega.
        </span>{' '}
        Pro nahrání dalších datových zdrojů, úpravy chování či vzhledu AI
        chatbotu{' '}
        <span className='font-semibold text-[#1a1a1a]'>zadejte e-mail</span>, na
        který Vám z bezpečnostních důvodů přijde potvrzovací odkaz. Dále
        pokračujte dle našich návodů.
      </p>
      <RegisterForm organizationId={organizationId} />
    </Wrapper>
  );
}
